var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9408 0.493421C12.9408 0.221053 12.7197 0 12.4474 0H0.993421C0.721053 0 0.5 0.221053 0.5 0.493421V3.94737C0.5 4.21974 0.721053 4.44079 0.993421 4.44079H12.4474C12.7197 4.44079 12.9408 4.21974 12.9408 3.94737V0.493421Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9408 8.49342C12.9408 8.22105 12.7197 8 12.4474 8H0.993421C0.721053 8 0.5 8.22105 0.5 8.49342V11.9474C0.5 12.2197 0.721053 12.4408 0.993421 12.4408H12.4474C12.7197 12.4408 12.9408 12.2197 12.9408 11.9474V8.49342Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.94caba8e6626c681c8b1f4f5a127fac4.svg";
export { ForwardRef as ReactComponent };